package foatto.core_compose_web.model

class TitleData(val url: String, val text: String)
